import styled from '@emotion/styled';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import React from 'react';

export interface ISearchProps extends InputProps {}

const Search: React.FC<ISearchProps> = ({ ...props }) => {
  return <Input.Search {...props} />;
};

export default styled(Search)``;
